import React from 'react';
import { Button, ButtonProps } from '../button/button';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuLabel,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Typography } from '../typography';
import clsx from 'clsx';

interface Props {
	label: string;
	confirmMessage: string;
	buttonLabel: string;
	decoration?: ButtonProps['decoration'];
	size?: ButtonProps['size'];
	classNameDropdownMenuContent?: string;
	buttonIcon?: ButtonProps['icon'];
	buttonIconRight?: ButtonProps['iconRight'];
	disabled?: boolean;
	incompleted?: boolean;
	className?: string;
	onClickConfirm: () => void | Promise<void>;
	onClickButton?: () => void | Promise<void>;
}

export const ButtonDropdownConfirm: React.FC<Props> = ({
	label,
	confirmMessage,
	buttonLabel,
	decoration = 'primary',
	size = 'medium',
	classNameDropdownMenuContent,
	disabled,
	incompleted,
	buttonIcon,
	buttonIconRight,
	className,
	onClickConfirm,
	onClickButton,
}) => {
	const [open, setOpen] = React.useState(false);
	return (
		<DropdownMenu
			modal={false}
			open={open}
			onOpenChange={() => {
				if (!disabled && !incompleted) setOpen(!open);
			}}
		>
			<div className={clsx('relative', className)}>
				<DropdownMenuTrigger>
					<Button
						size={size}
						decoration={decoration}
						classNameButton="!z-50 !size-4"
						className={clsx({
							'!bg-[#B18EE0] !border-[#B18EE0] hover:!bg-[#B18EE0] focus:!bg-[#B18EE0] cursor-default':
								incompleted,
						})}
						disabled={incompleted ? false : disabled}
						icon={buttonIcon}
						iconRight={buttonIconRight}
						label={label}
						onClick={onClickButton}
						classNameLabel={`${
							label.includes('Demand') && label.length > 15
								? 'text-[15px] 2xl:text-base'
								: 'text-base'
						}`}
					/>
				</DropdownMenuTrigger>
				<DropdownMenuContent
					className={clsx(
						'p-6 rounded-3xl space-y-6 w-[224px]',
						classNameDropdownMenuContent
					)}
				>
					<DropdownMenuLabel className="px-0">
						<Typography type="regular-16" className="text-center">
							{confirmMessage}
						</Typography>
					</DropdownMenuLabel>
					<Button
						disabled={disabled}
						onClick={() => {
							onClickConfirm();
							setOpen(false);
						}}
						decoration="primary"
						size="small"
						className="w-[115px] h-[30px] !py-4 px-6 m-auto"
					>
						{buttonLabel}
					</Button>
				</DropdownMenuContent>
			</div>
		</DropdownMenu>
	);
};
